import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../../Base/helper/baseFunctions";


export const GetVisitorManagementReasonHelper = async (params) => {
    
    return await axiosInstance(`/visitors/getVisitorManagementReason`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
        }
    })
    .then((res) => {
        return { message: "Reasons retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        return { message: "Unable to retrieve reasons", hasError: true, data: err?.response?.data }
    });
};

export const AddVisitorManagementReasonHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/visitors/addVisitorManagementReason`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            reason: params?.reason,

        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Reason added successfully");
        return { message: "Reason added successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to add reason", hasError: true, data: err?.response?.data }
    });
};

export const UpdateVisitorManagementReasonHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/visitors/updateVisitorManagementReason`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            reason: params?.reason,
            visitors_management_reasons_pk: params?.visitors_management_reasons_pk,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Reason updated successfully");
        return { message: "Reason updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update reason", hasError: true, data: err?.response?.data }
    });
};

export const DeleteVisitorManagementReasonHelper = async (params) => {
    toast.dismiss();
    toast.info("Deleting...");
    return await axiosInstance(`/visitors/deleteVisitorManagementReason`, {
        method: "DELETE",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            visitors_management_reasons_pk: params?.visitors_management_reasons_pk,

        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Reason deleted successfully");
        return { message: "Reason deleted successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to delete reason", hasError: true, data: err?.response?.data }
    });
};
